<template>
  <el-main>
    <div class="tool" shadow="never">
      <el-button size="small" @click="handleShowALL">显示全部</el-button>
      <!-- 新增 -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleAddDic"
        >添加字典项</el-button
      >

      <!-- 占位 -->
      <div style="flex: 1"></div>
    </div>

    <div class="layout">
      <div class="orgwrapper">
        <el-table
          :data="dicCategorys"
          border
          style="width: 100%"
          height="100%"
          size="small"
          row-key="id"
          highlight-current-row
          @row-click="handleClick"
        >
          <el-table-column
            prop="name"
            label="字典分类"
            align="center"
            width="0"
          ></el-table-column>
        </el-table>
      </div>

      <div class="table-wrapper">
        <el-table
          v-loading="loading"
          element-loading-text="拼命加载中"
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          max-height="800"
          size="small"
        >
          <el-table-column
            prop="name"
            label="字典项名称"
            align="center"
            width="0"
          ></el-table-column>

          <el-table-column
            prop="code"
            label="字典项值"
            align="center"
            width="0"
          ></el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="250px"
            align="center"
          >
            <template #default="scope">
              <el-button
                type="primary"
                size="small"
                plain
                icon="el-icon-edit"
                title="编辑"
                @click.prevent="handleEdit(scope.$index, scope.row)"
              >
              </el-button>

              <el-button
                type="danger"
                size="small"
                plain
                icon="el-icon-delete"
                title="删除"
                @click.prevent="handleDelete(scope.$index, scope.row)"
              >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 操作员编辑框 -->
    <el-dialog
      :title="'字典编辑,分类[' + this.currentCategory.name + ']'"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="handleClose"
      top="5vh"
    >
      <el-form
        :model="dictionary"
        :rules="rules"
        ref="editForm"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm"
      >
        <input type="hidden" name="id" v-model.number="dictionary.id" />
        <el-row>
          <!-- 名称 -->
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model.trim="dictionary.name"
                autocomplete="off"
                maxlength="20"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>

          <!-- 值 -->
          <el-col :span="24">
            <el-form-item label="值" prop="code">
              <el-input
                v-model.trim="dictionary.code"
                autocomplete="off"
                maxlength="20"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
export default {
  name: "Dictionary",
  data() {
    return {
      loading: false,
      dicCategorys: [],
      currentCategory: {
        id: null,
        name: null,
      },

      dictionarys: [],
      dictionary: {
        id: "",
        category: "",
        name: "",
        code: "",
      },

      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 15 个汉字",
            trigger: "blur",
          },
        ],

        code: [
          { required: true, message: "请输入项目值", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
      },

      dialogVisible: false,
    };
  },

  computed: {
    tableData() {
      if (this.currentCategory.name) {
        return this.dictionarys.filter(
          (x) => x.category == this.currentCategory.name
        );
      } else {
        return this.dictionarys;
      }
    },
  },

  mounted() {
    this.fetchTypes();
    this.fetchDics();
  },

  methods: {
    /**
     * 获取字典类型
     */
    fetchTypes() {
      this.loading = true;
      this.$axios
        .get("/dictionary/category")
        .then((response) => {
          const { data } = response;
          this.dicCategorys = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    /**
     * 获取字典数据
     */
    fetchDics() {
      this.$axios
        .get("/dictionary")
        .then((response) => {
          const { data } = response;
          this.dictionarys = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    handleClick(row) {
      this.currentCategory.id = row.id;
      this.currentCategory.name = row.name;
    },

    handleAddDic() {
      if (!this.currentCategory.name) {
        this.$message.error("请先选择左边的分类");
        return;
      }
      this.dictionary = {
        id: null,
        category: this.currentCategory.name,
        name: "",
        code: "",
      };

      this.dialogVisible = true;
    },

    handleEdit(index, row) {
      this.dictionary = Object.assign({}, row);
      this.dialogVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm(`确定要删除 ${row.name} 此条记录吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete("/dictionary/" + row.id)
            .then((response) => {
              if (response.data.code == "200") {
                this.$message.success("删除成功");
                this.fetchDics();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          //取消删除
        });
    },
    // 保存操作处理
    handleSave() {
      console.log(this.dictionary);
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/dictionary", this.dictionary)
            .then((response) => {
              if (response.data.code == "200") {
                this.$message.success("保存成功" + response);
                this.dialogVisible = false;
                this.fetchDics();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // 表单验证不通过
          this.$message.error("信息填写不正确");
        }
      });
    },

    handleClose() {
      this.$refs["editForm"].clearValidate();
      this.dialogVisible = false;
    },

    handleShowALL() {
      this.currentCategory.id = null;
      this.currentCategory.name = null;
    },
  },
};
</script>



<style lang="scss">
.layout {
  flex: 1;
  overflow-y: hidden;
  display: flex;
  .orgwrapper {
    width: 250px;
  }
}
</style>